import useSWR from "swr";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import {
  StripeOrderDTO,
  StripeOrderStatus,
} from "../../Stripe/StripeOrderDTO.ts";
import {
  OrdersListQuery,
  OrdersPage,
  toOrdersApiParams,
} from "../OrdersList/OrdersListQuery.ts";

export function useGetAllStripeOrders(
  query: OrdersListQuery<StripeOrderStatus>,
) {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const params = toOrdersApiParams(query);
  const { data, error, isLoading, mutate } = useSWR(
    ["stripe", "/admin/orders", JSON.stringify(params)],
    async ([, url]) => {
      const { data } = await createAxiosInstance().get<
        OrdersPage<StripeOrderDTO>
      >(url, { params });
      return data;
    },
    { keepPreviousData: true },
  );

  return {
    orders: data?.orders ?? [],
    total: data?.total ?? 0,
    error,
    isLoading: isLoading && data === undefined,
    mutate,
  };
}
